export default {
    1: [{
        description: '胰島素是什麼？',
        options: ['主要降血壓', '降血糖\n荷爾蒙'],
        answer: 1,
        explain: '胰島素為人體本來就會分泌的降血糖荷爾蒙，不具有成癮性',
    }, {
        description: '打胰島素會上癮嗎？',
        options: ['會', '不會'],
        answer: 1,
        explain: '胰島素為人體本來就會分泌的降血糖荷爾蒙，不具有成癮性',
    }],
    2: [{
        description: '何時應考慮使用胰島素治療？',
        options: ['初診斷糖化血色素過高(大於9%)', '併發症出現再用就好'],
        answer: 0,
        explain: '符合用3種以上降糖口服藥、初診斷糖化血色素過高(大於9%)、明顯高血糖症狀，任一情形應立即請主治醫師評估是否需要胰島素',
    }],
    3: [{
        description: '糖尿病早期就能使用胰島素治療嗎？',
        options: ['能', '不能'],
        answer: 0,
        explain: '愈早使用胰島素效果愈好，愈有機會改為口服藥治療',
    }],
    4: [{
        description: '腎病變、感覺麻木與血糖控制不佳逐漸讓胰島細胞過勞有關嗎？',
        options: ['有關', '無關'],
        answer: 0,
        explain: '長期血糖控制不佳逐漸會讓胰島細胞過勞',
    }],
    5: [{
        description: '補充胰島素讓胰島細胞休息，使血糖穩定就能遠離併發症風險嗎?',
        options: ['能', '不能'],
        answer: 0,
        explain: '是的！每降低1%A1C為身體帶來許多好處',
    }],
    6: [{
        description: '施打胰島素會疼痛嗎？',
        options: ['一定很痛', '幾乎沒感覺'],
        answer: 1,
        explain: '胰島素已成功治療糖尿病滿100周年，針頭細如髮絲，多數糖友反應幾乎沒感覺！',
    }],
    7: [{
        description: '打胰島素可以外出旅行嗎？',
        options: ['可以', '不可以'],
        answer: 0,
        explain: '胰島素筆針外出攜帶方便，旅行不受影響!',
    }, {
        description: '懷孕可以打胰島素控制血糖嗎？',
        options: ['可以', '不可以'],
        answer: 0,
        explain: '胰島素已成功治療糖尿病滿100周年，也有胰島素筆針的選項，使用上更方便，孕婦嬰幼兒也可用！',
    }],
    8: [{
        description: '我可以選擇讓胰島細胞喘息早一點打胰島素嗎？',
        options: ['先與醫生討論，尋求專業建議', '不急，之後再說'],
        answer: 0,
        explain: '血糖控制好，有3大好處唷！',
    }],
};
